import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { ThreePointLeaderIcon } from '@lean-body/components/atoms';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
export const ThreePointLeader = ({ classObject, onClick }) => {
    return (React.createElement("div", { className: css(styles.container, classObject), onClick: onClick },
        React.createElement(ThreePointLeaderIcon, null)));
};
const styles = StyleSheet.create({
    container: {
        background: `linear-gradient(180deg, ${Colors.White} 0%, rgba(255, 255, 255, 0) 100%), ${Colors.White}`,
        borderRadius: 24,
        width: 34,
        height: 34,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        [MediaBreakPointUp.MD]: {
            width: 36,
            height: 36,
        },
    },
});
